{
	"Id": "ID:",
	"IdPlaceholder": "[Auto Assigned]",
	"NamePlaceholder": "Central Management Environment",
	"BillingId": "Billing ID:",
	"ParentCme": "Parent CME:",
	"DescriptionIsRequired": "Description is required.",
	"NAME": "CMEDetails",
	"CMEDetails_ButtonHelpLabel": "Help?",
	"CMEDetails_ButtonSubmitLabel": "OK",
	"CMEDetails_ButtonCancelLabel": "Cancel",
	"CMEDetails_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
	"CMEDetails_PromptConfirm": "Yes",
	"CMEDetails_PromptCancel": "Cancel",
	"CMEDetails_Description": "Description:",
	"CMEDetails_ProviderIDS": "SSO Provider IDs:",
	"CMEDetails_Disable_Akixi_Login": "Disable Username login capability:",
	"CMEDetails_ProviderIDS_Help": "Leave blank unless you are configuring Single-Sign On (SSO). Your provider ID will have been provided if you are using SSO.",
	"CMEDetails_ProviderIDS_Validation_NoMoreThan5": "No more than 5 SSO Provider IDs are allowed.",
	"CMEDetails_ProviderIDS_Validation_IDsInvalid": "Make sure Provider IDs are letters, numbers, hyphens or underscores only, are no longer than 15 characters and are in a comma separated list."
}